import moment from "moment";
import { customerConfig } from "../../customerConfig";

export function templateCustomerData(data) {
  const name = [data?.firstName, data?.lastName]
    ?.filter((nm) => Boolean(nm))
    .join(" ");
  const accountManager = [
    data?.detail?.accountManager?.firstName,
    data?.detail?.accountManager?.lastName,
  ]
    ?.filter((item) => Boolean(item))
    .join(" ");

  const documentsSubmitted =
    Boolean(data?.detail?.CACCertificateDoc) &&
    Boolean(data?.detail?.CACCO2Doc) &&
    Boolean(data?.detail?.CACC07Doc) &&
    Boolean(data?.detail?.identityVerificationDoc);
  return [
    {
      elements: [
        {
          type: "customerModal",
          value: data?.detail?.agencyName,
        },
        {
          type: data?.detail?.agencyName ? "title" : "customerModal",
          value: name,
        },
        {
          type: "title",
          value: data?.email,
        },
      ],
      value: "",
      width: "md:w-[25%]",
    },
    // {
    //   elements: [
    //     // {
    //     //   type: "title",
    //     //   value: "Email",
    //     // },
    //     {
    //       type: "text",
    //       value: data?.email,
    //     },
    //   ],
    //   value: "",
    //   width: "md:w-[15%]",
    // },
    {
      elements: [
        // {
        //   type: "title",
        //   value: "Email",
        // },
        {
          type: "text",
          value: accountManager || "------",
        },
      ],
      value: "",
      width: "md:w-[20%]",
    },
    // {
    //   elements: [
    //     {
    //       type: "text",
    //       value: `+${data?.phone}`,
    //     },
    //   ],
    //   value: "",
    //   width: "md:w-[15%]",
    // },
    {
      elements: [
        {
          type: "agencyStatus",
          value: data?.detail?.isVerified
            ? customerConfig.filterTabs.verified.code
            : data?.detail?.requestedVerification && documentsSubmitted
            ? customerConfig.filterTabs.awaitingVerification.code
            : data?.detail?.requestedVerification
            ? customerConfig.filterTabs.awaitingDocuments.code
            : customerConfig.filterTabs.notSubmitted.code,
        },
      ],
      width: "md:w-[15%]",
    },
    {
      elements: [{ type: "abilityStatus", value: data?.accountStatus }],
      width: "md:w-[10%]",
    },
    {
      elements: [
        // { type: "title", value: "Registered at" },
        { type: "text", value: moment(data?.createdAt).format("YYYY/MM/DD") },
        { type: "title", value: moment(data?.createdAt).format("hh:mm A") },
      ],
      width: "md:w-[10%]",
    },
  ];
}
